module.exports = __webpack_public_path__ + "img/logo_tron.ffbffff4.png";